import React, { Component } from 'react';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { handleQualtricsClick, FEEDBACK_ID } from '../../../shared-utilities/qualtrics';

const LOCALE_PREFIX = 'inc/footer';

export class FooterLinks extends Component {
    static propTypes = {
        featureFlags: PropTypes.object,
        viewName: PropTypes.string,
        isTeslaFlow: PropTypes.bool
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { viewName, featureFlags, isTeslaFlow } = this.props;
        const year = new Date().getFullYear();
        let feebackLink;
        if (featureFlags && featureFlags.wireOnFeedback) {
            feebackLink = (
                <a href="#"
                    data-automation-id="feedback"
                    className="cue-footer-link oo-feedback"
                    name="CAPEQualtricFeedback-Footer"
                    id="cape_qualtric_feedback"
                    onClick={(e) => handleQualtricsClick(e, FEEDBACK_ID)}
                >
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.applyForBML.feedback`}
                    />
                </a>
            );
        }
        const hideLinks = isTeslaFlow;
        if (hideLinks) {
            return (
                <div className="footerLinks">
                    {feebackLink}
                </div>
            );
        } else {
            return (
                <div className="footerLinks">
                    <a href="https://www.paypal.com/us/webapps/mpp/popup/about-payment-methods"
                        data-automation-id="policiesLink"
                        className="cue-footer-link"
                        target="_blank"
                        name="PayPalPolicies-Footer"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.applyForBML.policies`}
                        />
                    </a>
                    <a href="https://www.paypal.com/us/webapps/mpp/ua/legalhub-full"
                        data-automation-id="termsLink"
                        className="cue-footer-link"
                        target="_blank"
                        name="PayPalTerms-Footer"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.applyForBML.terms`}
                        />
                    </a>
                    <a href="https://www.paypal.com/us/webapps/mpp/ua/privacy-full"
                        data-automation-id="privacyLink"
                        className="cue-footer-link"
                        target="_blank"
                        name="PayPalPrivacy-Footer"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.applyForBML.privacy`}
                        />
                    </a>
                    {feebackLink}
                    <span className="cue-footer-link">© 1999-{year}</span>
                    <div id="cue-security-icon" />
                </div>
            );
        }
    }
}

export const mapStateToProps = state => ({
    featureFlags: state.serverData.featureFlags,
    viewName: state.serverData.viewName,
    isTeslaFlow: _.get(state, 'serverData.flow') === FLOW_TYPE.TESLA
});

export default connect(mapStateToProps)(FooterLinks);
